import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import { InvoiceDigestStatus } from 'anchor-scout-common/types';
import { Divider, TableList, Typography } from 'seagull';
import { routes } from "../../../constants";
import { invoiceStatusToColor } from "./InvoicesDigestWidget";
import styles from "./InvoicesDigestWidget.module.scss";
import { invoicePaymentStatusMap } from "./InvoicesDigestWIdget.utils";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const renderCell = _ref => {
  let {
    value,
    testid
  } = _ref;
  return {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": testid,
      children: value
    })
  };
};
const renderDivider = () => /*#__PURE__*/_jsx(Divider, {
  margin: 0
});
const renderHeaderItem = value => ({
  value: /*#__PURE__*/_jsx(Typography, {
    weight: "normal",
    children: value
  })
});
const {
  columnDefs,
  headerItems
} = (() => {
  const config = [{
    columnDef: {
      width: 240
    },
    headerItem: renderHeaderItem('Type')
  }, {
    columnDef: {
      width: [60, 80],
      hAlign: 'end'
    },
    headerItem: renderHeaderItem('Invoices')
  }, {
    columnDef: {
      width: [100, 150],
      hAlign: 'end'
    },
    headerItem: renderHeaderItem('Amount')
  }];
  return {
    columnDefs: config.map(i => i.columnDef),
    headerItems: config.map(i => i.headerItem)
  };
})();
const invoiceTypeToTypeCellText = type => {
  switch (type) {
    case InvoiceDigestStatus.RequiresClientApproval:
      return 'Requires client approval';
    case InvoiceDigestStatus.PaymentsVerificationRequired:
      return 'Payment validation required';
    case InvoiceDigestStatus.MissingPaymentMethod:
      return 'Missing payment method';
    case InvoiceDigestStatus.Failed:
      return 'Payment failed';
    case InvoiceDigestStatus.Disputed:
      return 'Payment disputed';
    case InvoiceDigestStatus.PaymentStopped:
      return 'Payment stopped';
    case InvoiceDigestStatus.PaymentMethodUnverified:
      return 'Payment method unverified';
  }
};
function InvoiceInfoRow(_ref2) {
  let {
    invoiceStatusGroup,
    invoiceType,
    testid,
    className,
    isLast
  } = _ref2;
  const paymentStatus = 'paymentStatus';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TableList.Row, {
      disableMarginBottom: true,
      highlightOnHover: true,
      as: NavLink,
      size: "fluid",
      className: className,
      to: "".concat(routes.invoicesDashboard, "?").concat(paymentStatus, "=").concat(invoicePaymentStatusMap[invoiceType]),
      "data-testid": testid,
      items: [{
        value: /*#__PURE__*/_jsxs("div", {
          className: cn(styles.dotContainer),
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.dot,
            style: {
              background: invoiceStatusToColor[invoiceType]
            }
          }), /*#__PURE__*/_jsx(Typography, {
            children: invoiceTypeToTypeCellText(invoiceType)
          })]
        })
      }, renderCell({
        value: invoiceStatusGroup.count.toString()
      }), renderCell({
        value: invoiceStatusGroup.amount.display()
      })]
    }), !isLast && renderDivider()]
  });
}
function InvoicesInfoTable(_ref3) {
  let {
    invoiceDigestModel
  } = _ref3;
  const invoicesInfoRowTestId = type => "invoices-digest-".concat(type, "-row");
  const rows = invoiceDigestModel.invoiceTypesToDisplay();
  const className = invoiceDigestModel.numInvoiceTypes() < 6 ? styles.lessThanSixItemsInvoiceInfoRow : styles.sixItemsInvoiceInfoRow;
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "invoice-digest-table",
    children: /*#__PURE__*/_jsxs(TableList.Provider, {
      variant: "minimal",
      columnDefs: columnDefs,
      hPadding: "xs",
      children: [/*#__PURE__*/_jsx(TableList.Header, {
        items: headerItems,
        bgColor: "transparent"
      }), renderDivider(), rows.map((invoiceType, idx) => {
        const invoiceStatusGroup = invoiceDigestModel.invoiceTypeToInvoicesGroup(invoiceType);
        return /*#__PURE__*/_jsx(InvoiceInfoRow, {
          testid: invoicesInfoRowTestId(invoiceType),
          invoiceType: invoiceType,
          invoiceStatusGroup: invoiceStatusGroup,
          className: className,
          isLast: idx === rows.length - 1
        }, invoiceType);
      })]
    })
  });
}
export default InvoicesInfoTable;